import script from "./BookDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./BookDetails.vue?vue&type=script&setup=true&lang=js"

import "./BookDetails.vue?vue&type=style&index=0&id=58166516&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58166516"]])

export default __exports__